import { createSlice } from '@reduxjs/toolkit'

import { scenariosAdapter } from '../adapters/scenariosAdapter'
import { planningApi } from '../apis/planningApi'

export const initialScenarioState = scenariosAdapter.getInitialState()

export const scenariosSlice = createSlice({
  name: 'scenarios',
  initialState: initialScenarioState,
  reducers: {
    upsertMultipleScenarios: (state, action) => {
      scenariosAdapter.upsertMany(state, action.payload)
    },
    replaceAllScenarios: (state, action) => {
      scenariosAdapter.setAll(state, action.payload)
    },
    removeAllScenarios: scenariosAdapter.removeAll,
  },
  extraReducers: (builder) => {
    builder.addMatcher(planningApi.endpoints.deleteScenario.matchFulfilled, (state, action) => {
      const scenarioId = action.meta.arg.originalArgs

      scenariosAdapter.removeOne(state, scenarioId)
    })
  },
})

export const { upsertMultipleScenarios, replaceAllScenarios, removeAllScenarios } = scenariosSlice.actions